// src/pages/index.js - Barrel export con lazy loading
import { lazy } from "react";

// Lazy imports para páginas
export const Home = lazy(() => import("./Home/Home"));
export const ProductCatalog = lazy(() =>
  import("./ProductCatalog/ProductCatalog")
);
export const ProductDetail = lazy(() =>
  import("./ProductDetail/ProductDetail")
);
export const QuotesPage = lazy(() => import("./Quotes/QuotesPage"));

// Lazy imports para componentes grandes
export const QuoteForm = lazy(() => import("../components/forms/QuoteForm"));
export const ContactForm = lazy(() =>
  import("../components/forms/ContactForm")
);
